export default "__VITE_ASSET__Cq$5xm5K__"